import script from "./ShowExplain.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowExplain.vue?vue&type=script&setup=true&lang=js"

import "./ShowExplain.vue?vue&type=style&index=0&id=3f8cb307&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f8cb307"]])

export default __exports__